import { render, staticRenderFns } from "./approve-details.vue?vue&type=template&id=78c11b92&scoped=true&"
import script from "./approve-details.vue?vue&type=script&lang=js&"
export * from "./approve-details.vue?vue&type=script&lang=js&"
import style0 from "./approve-details.vue?vue&type=style&index=0&id=78c11b92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c11b92",
  null
  
)

export default component.exports